import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { CtPhishingTemplateList } from 'containers';
import { MyPageTitle, MyPageTemplate, PhishingTemplateMenu } from 'components';

class CtExamTemplate extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    return (
      <MyPageTemplate className="table">
        <MyPageTitle
          templatePage="templatePage phishing"
          title={defineMessages(formatMessage({ id: 'MyPageMenu_7', defaultMessage: '피싱 페이지' }))}>
          <PhishingTemplateMenu />
        </MyPageTitle>
        <CtPhishingTemplateList />
      </MyPageTemplate>
    );
  }
}

CtExamTemplate.propTypes = {};
CtExamTemplate.defaultProps = {};

export default injectIntl(CtExamTemplate);



// WEBPACK FOOTER //
// ./src/script/containers/phishingTemplate/CtPhishingTemplate.js